import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Products from "../../Components/Products/Products";
import "./ProductList.css";

const ProductList = () => {
  const { isLoading, error, data } = useQuery(
    ["repoData"],
    () =>
      axios
        .get("https://api.publicapis.org/entries")
        .then((res: { data: { entries: [] } }) => res.data.entries),
    { staleTime: 30000 }
  );

  if (isLoading)
    return (
      <p className='h1 d-flex justify-content-center mt-10 h-full items-center'>
        Loading...
      </p>
    );

  if (error)
    return (
      <p className='h1 d-flex justify-content-center mt-10 h-full items-center'>
        Caching high volume websites
      </p>
    );

  return (
    <div className='productlist bg-stone-300'>
      {data &&
        data.map((item: any) => (
          <Products key={item.Link} item={item}></Products>
        ))}
    </div>
  );
};

export default ProductList;
